/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ViewBox from "vux/src/components/view-box/index.vue";
import { mapState } from 'vuex';
import { isQuickDeploy } from '@/api';
import ExtraBtn from './subPages/ExtraBtn';
export default {
  components: {
    ExtraBtn: ExtraBtn,
    ViewBox: ViewBox
  },
  data: function data() {
    return {
      transitionName: '',
      startPosition: '',
      endPosition: '',
      showInitDeploy: false
    };
  },
  computed: _objectSpread({}, mapState('globalStore', ['isInMain', 'showHomebottomBar', 'keepAliveList', 'RUN_ENV', 'user'])),
  watch: {
    $route: function $route(to, from) {
      if (!(['Home', 'Operation', 'Order', 'Mine'].indexOf(to.name) !== -1 && ['Home', 'Operation', 'Order', 'Mine'].indexOf(from.name) !== -1)) {
        var toDepth = to.path.split('/').length;
        var fromDepth = from.path.split('/').length;
        this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left';
      } else {
        this.transitionName = '';
      }
    }
  },
  mounted: function mounted() {
    var loadingMask = document.getElementById('loadingDiv');
    if (loadingMask) loadingMask.parentNode.removeChild(loadingMask); // if (this.$DingTalk) {
    //   // 隐藏右上角按钮
    //   this.$DingTalk.biz.navigation.setRight({
    //     show: false,
    //   })
    //   // 禁用下拉刷新
    //   this.$DingTalk.ui.pullToRefresh.disable()
    //   // 禁用bounce
    //   this.$DingTalk.ui.webViewBounce.disable()
    // }
    // if (this.RUN_ENV === 'Android') {
    //   this.$setBackbuttonListen()
    // }
    // this.quickDeploy()
    // this.$root.$on('quickDeploy', () => this.quickDeploy())
  },
  methods: {
    quickDeploy: function quickDeploy() {
      var _this = this;

      if (this.$oauth('09001')) {
        // 系统管理员 查看是否已快速部署
        isQuickDeploy().then(function (res) {
          if (res.success && !res.data.is_quick_deploy) {
            _this.showInitDeploy = true;
          }
        });
      }
    }
  }
};